import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ReactNode } from "react";

// Shared shell for the catalog authoring dialogs (MPN-1207): title, error banner
// (server 422/409 messages), and Cancel/Save actions with a saving spinner-lock.
export function FormDialog({
  open, title, onClose, onSave, saving, error, canSave = true, saveLabel = "Save",
  maxWidth = "sm", children,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSave: () => void;
  saving: boolean;
  error: string | null;
  canSave?: boolean;
  saveLabel?: string;
  /** Widen for a dialog that holds a table rather than a stack of fields. */
  maxWidth?: "sm" | "md";
  children: ReactNode;
}) {
  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          {children}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button variant="contained" onClick={onSave} disabled={saving || !canSave}>
          {saveLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
